import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { DocumentType } from "@/components/features/FileUploader";

export const useDocumentTypes = () => {
  return useQuery({
    queryKey: ["documentTypes"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("document_types")
        .select("*")
        .order("name");

      if (error) {
        console.error("Error fetching document types:", error);
        throw error;
      }
      return (data as DocumentType[]) || [];
    },
    // Keep document types fresh for a long time since they rarely change
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
    gcTime: 1000 * 60 * 60 * 24 // 24 hours
  });
};
